import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { setCurrentPathname, setRouterNavigate } from '@root/app/shared/navigation/navigation.service';
import { authService } from '@root/app/shared/new-services/auth.service';
import { stopStatusPolling } from '@root/app/shared/new-services/company_status.service';

const RouterNavigationSync: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        setRouterNavigate(navigate);
    }, [navigate]);

    useLayoutEffect(() => {
        setCurrentPathname(location.pathname);
        if (!authService.isLoggedIn()) {
            stopStatusPolling();
        }
    }, [location.pathname]);

    return null;
};

export default RouterNavigationSync;
